const EUROPE_COUNTRY_CODES = new Set([
  "AD", "AL", "AT", "BA", "BE", "BG", "BY", "CH", "CY", "CZ", "DE", "DK",
  "EE", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LI",
  "LT", "LU", "LV", "MC", "MD", "ME", "MK", "MT", "NL", "NO", "PL", "PT",
  "RO", "RS", "SE", "SI", "SK", "SM", "UA", "UK", "VA", "XK",
]);

const COUNTRY_NAME_TO_CODE = {
  andorra: "AD",
  albania: "AL",
  austria: "AT",
  "bosnia and herzegovina": "BA",
  belgium: "BE",
  bulgaria: "BG",
  belarus: "BY",
  switzerland: "CH",
  cyprus: "CY",
  "czech republic": "CZ",
  czechia: "CZ",
  germany: "DE",
  denmark: "DK",
  estonia: "EE",
  spain: "ES",
  finland: "FI",
  france: "FR",
  "united kingdom": "GB",
  "great britain": "GB",
  greece: "GR",
  croatia: "HR",
  hungary: "HU",
  ireland: "IE",
  iceland: "IS",
  italy: "IT",
  liechtenstein: "LI",
  lithuania: "LT",
  luxembourg: "LU",
  latvia: "LV",
  monaco: "MC",
  moldova: "MD",
  montenegro: "ME",
  "north macedonia": "MK",
  macedonia: "MK",
  malta: "MT",
  netherlands: "NL",
  norway: "NO",
  poland: "PL",
  portugal: "PT",
  romania: "RO",
  serbia: "RS",
  sweden: "SE",
  slovenia: "SI",
  slovakia: "SK",
  "san marino": "SM",
  ukraine: "UA",
  "vatican city": "VA",
  kosovo: "XK",
  argentina: "AR",
  chile: "CL",
  colombia: "CO",
  peru: "PE",
  perú: "PE",
  venezuela: "VE",
  ecuador: "EC",
  bolivia: "BO",
  paraguay: "PY",
  uruguay: "UY",
  brazil: "BR",
  brasil: "BR",
  mexico: "MX",
  méxico: "MX",
  "costa rica": "CR",
  panama: "PA",
  panamá: "PA",
  cuba: "CU",
  guatemala: "GT",
  honduras: "HN",
  nicaragua: "NI",
  "el salvador": "SV",
  "dominican republic": "DO",
  "república dominicana": "DO",
};

export function normalizeCountryCode(value) {
  if (value == null) return "";
  const raw = String(value).trim();
  if (!raw) return "";
  if (/^[A-Za-z]{2}$/.test(raw)) return raw.toUpperCase();
  return COUNTRY_NAME_TO_CODE[raw.toLowerCase()] || "";
}

export function isEuropeanCountry(countryNameOrCode) {
  return EUROPE_COUNTRY_CODES.has(normalizeCountryCode(countryNameOrCode));
}

export { EUROPE_COUNTRY_CODES };
